import { render, staticRenderFns } from "./document-account-edit.vue?vue&type=template&id=5ddf4f6c&scoped=true&"
import script from "./js/document-account-edit.js?vue&type=script&lang=js&"
export * from "./js/document-account-edit.js?vue&type=script&lang=js&"
import style0 from "./document-account-edit.vue?vue&type=style&index=0&id=5ddf4f6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf4f6c",
  null
  
)

export default component.exports